import { AboutCourseFieldsFieldsLearningFormatEnum, LanguageCodes } from '@academica-box/swagger/academgen'

export const LearningFormatMap = {
  [AboutCourseFieldsFieldsLearningFormatEnum.Online]: 'Онлайн',
  [AboutCourseFieldsFieldsLearningFormatEnum.Offline]: 'Оффлайн',
}

export const CourseTypeMap = {
  external_course: 'Курс',
  vendor_pack: 'Программа',
  course: 'Курс',
} as {
  [key: string]: string;
}

export const LanguageMap = {
  [LanguageCodes.Ru]: 'На русском языке',
  [LanguageCodes.En]: 'На английском языке',
  [LanguageCodes.Uz]: 'На узбекском языке',
  [LanguageCodes.Kz]: 'На казахском языке',
}
